import { SvgIcon, SxProps } from "@mui/material";
import SvgFacebookIcon from "jsx:../../../Images/Icons/FontAwesome/brands/facebook.svg";

export function FacebookIcon(props: SxProps) {
    return <SvgIcon component={SvgFacebookIcon} inheritViewBox sx={props} />;
}
